import React from 'react';

import { mosaiqStyled } from '../../lib';

import { CardActionProps } from './types';

import { CardActionContainer } from './CardAction.styles';

const CardAction = mosaiqStyled<CardActionProps, HTMLDivElement>(({ children, ...props }) => {
  return <CardActionContainer {...props}>{children}</CardActionContainer>;
});

CardAction.displayName = 'CardAction';

export default CardAction;
